/**
 * Funkce pro omezení výběru hodnot ve dvou datepickerech navzájem
 *
 * Př. mám dva date pickery OD DO, pokud v prvním vyberu datum 16.12.2023 ve druhém se nastaví min datum na 16.12.2023.
 * Při změně data v druhém date pickeru je chování obdobné jen se nastaví max datum pro pro první picker
 *
 * Propojení pickerů probíhá přes data atributy "data-date-from-to-start" a "data-date-from-to-end" v hodnotě těchto atributů je potřeba mít id "protějšího" pickeru.
 */
function setupMinDatePicker(minDate) {
	let min = minDate.value;
	let maxDate = document.getElementById(minDate.dataset.dateFromToStart);
	if (maxDate === null) {
		return;
	}

	if (typeof maxDate.dataset.defaultMinDate === 'undefined') {
		maxDate.dataset.defaultMinDate = maxDate.min;
	}

	if (min !== '') {
		maxDate.min = min;
	} else {
		maxDate.min = maxDate.dataset.defaultMinDate;
	}
}

function setupMaxDatePicker(maxDate) {
	let max = maxDate.value;
	let minDate = document.getElementById(maxDate.dataset.dateFromToEnd);
	if (minDate === null) {
		return;
	}

	if (typeof minDate.dataset.defaultMaxDate === 'undefined') {
		minDate.dataset.defaultMaxDate = minDate.max;
	}

	if (max !== '') {
		minDate.max = max;
	} else {
		minDate.max = minDate.dataset.defaultMaxDate;
	}
}

function initPickers(element) {
	element.querySelectorAll('[data-date-from-to-start]').forEach(function (minDate) {
		minDate.addEventListener('change', function (e) {
			setupMinDatePicker(minDate);
		});

		setupMinDatePicker(minDate); // setup on page load
	});

	element.querySelectorAll('[data-date-from-to-end]').forEach(function (maxDate) {
		maxDate.addEventListener('change', function (e) {
			setupMaxDatePicker(maxDate);
		});

		setupMaxDatePicker(maxDate); // setup on page load
	});
}

export default function () {
	$.nette.ext('limit-date-pickers-from-to', {
		init: function () {
			initPickers(document);

			this.ext('snippets', true).after(($el) => {
				if ($el.get(0)) {
					initPickers($el.get(0));
				}
			});
		}
	});
}
